import React, { useEffect, useState } from "react";
import PageSizeOptions from "../../PageSizeOptions";
import Pagination from "../../../comman/pagination";
import SearchableSelect from "../../../comman/SearchableSelect";
import { paginate, calculateIndex } from "../../../utlis/paginate";
import AddEditPermission from "../../AddEditPermission";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllRoles, loadWorkflowRoles, getRoleTypes, loadRoleTypes,
  loadWorkflowRolesByFilter, getFilterAllRoles, getWorkflowRolesLoading
} from "../../../app/store/workflowRole";
import { useNavigate, Link } from "react-router-dom"
import Moment from "react-moment";
import { Tab, Tabs } from "react-bootstrap";
import { setCurrentPageTitle, setCurrentRoute } from "../../../app/store/layoutUI";
import { getAlert } from "../../../services/appAlerts";

export default function WorkflowUser(props) {
  const workflowRolesList = useSelector(getAllRoles);
  const workflowRolesFilterList = useSelector(getFilterAllRoles);
  const roleTypes = useSelector(getRoleTypes);
  const isLoading = useSelector(getWorkflowRolesLoading);
  const totalUsers = workflowRolesList.reduce((a, v) => (a = a + v.activeUsers), 0);
  const [workflowRoles, setWorkflowRoles] = useState([]);
  const [filterData, setFilterData] = useState([]);
  //const [roleTypes, setRoleTypes] = useState([]);
  //const [totalUsers,setTotalUsers]=useState(0);
  const [rowsCount, setRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(5);
  const [applicationId, setApplicationId] = useState(0);
  const [permissionShowHide, setPermissionShowHide] = useState(false);
  const [rType, setrType] = useState("");
  const [rName, setrName] = useState("");
  const [rId, setRId] = useState("");
  const [dataType, setDataType] = useState("");
  const [isFiltering, setIsFiltering] = useState(false);
  const [selectedObj, setSelectedObj] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState(0);
  const [selectedKey, setSelectedKey] = useState("home");

  const route = [
    { url: "", name: "System Administration" },
    { url: "", name: "Authorized Users" },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Main Users"))
  }, [])

  useEffect(() => {
    document.body.classList.add("workflow-user-card-scroll");
    return () => {
      document.body.classList.remove("workflow-user-card-scroll");
    };
  }, []);

  useEffect(() => {
    dispatch(loadWorkflowRoles(pageSize, currentPage));
    dispatch(loadRoleTypes("WF Role Type"));
  }, []);

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(page, startIndex, endIndex);
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    setSelectedRoleId(0)
    if (dataType === "filter")
      getPagedData(workflowRolesFilterList, page, pageSize)
    else
      dispatch(loadWorkflowRoles(pageSize, page));
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    setSelectedRoleId(0)
    if (dataType === "filter")
      getPagedData(workflowRolesFilterList, currentTarget.value, pageSize);
    else
      dispatch(loadWorkflowRoles(currentTarget.value, currentPage));
  };

  const handleApplicationFiltered = ({ currentTarget }) => {
    setApplicationId(currentTarget.value);
  };

  const handleRefresh = () => {
    if (dataType === "filter") handleFilter();
    else dispatch(loadWorkflowRoles(pageSize, currentPage, true));
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    if (items.length > 0)
      setRowsCount(items[0].totalCount);

    setWorkflowRoles(items);
  };

  useEffect(() => {
    if (workflowRolesList.length > 0) {
      if (workflowRolesList.length > 0)
        setRowsCount(workflowRolesList[0].totalCount);
      setWorkflowRoles(workflowRolesList);
    }
  }, [workflowRolesList]);

  useEffect(() => {
    if (dataType !== "filter") return;
    setPageSize(5);
    setCurrentPage(1);
    getPagedData(workflowRolesFilterList, 1, 5);
  }, [workflowRolesFilterList, dataType]);

  const handleFilter = async () => {
    setIsFiltering(true);
    setDataType("filter");
    setWorkflowRoles([]);
    var dt = new FormData();
    dt.append("name", rName);
    dt.append("type", rType);
    dt.append("id", rId);
    dispatch(loadWorkflowRolesByFilter(dt));
    setSelectedRoleId(0);
    setTimeout(() => {
      setIsFiltering(false);
    }, 600);
  };

  const handleFilterCancel = () => {
    dispatch(loadWorkflowRoles(pageSize, currentPage))
    setrName("");
    setrType("");
    setRId("");
    setDataType("");
    setSelectedRoleId(0);
    setIsFiltering(false);
  };

  const handlePermissionShowHide = (isSaved = false) => {
    setSelectedRoleId(0);
    setSelectedObj(null);
    setSelectedKey("home");
    if (isSaved === true) {
      getAlert("", "Workflow User Permissions Updated Successfully", "success");
    }
  };

  const handleManagePerformer = () => {
    const roleObj = workflowRoles.filter(x => x.roleid === selectedRoleId);
    if (roleObj.length > 0) {
      navigate("/ManageWorkflowPerformer", { state: roleObj[0] });
    }
  }

  const handleResetSelection = () => {
    setSelectedRoleId(0);
    setSelectedObj(null);
  }

  const handleSelectRole = (item) => {
    if (selectedRoleId === item.roleid) {
      handleResetSelection();
    } else {
      setSelectedRoleId(item.roleid);
      setSelectedObj(item);
    }
  }

  const handleTabSelect = (tab) => {
    setSelectedKey(tab);
  }

  return (
    <React.Fragment>
      <style>{`
        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        .skeleton-cell.sk-radio  {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          margin: 0 auto;
        }

        .skeleton-row td {
          padding: 14px 16px !important;
        }

        .wf-main-card {
          background: rgba(255, 255, 255, 0.97) !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: 0 4px 24px -4px rgba(15, 23, 42, 0.06), 0 1px 4px -1px rgba(15, 23, 42, 0.04) !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: #ffffff !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-stats-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: transparent !important;
          border: 1px solid rgba(100, 116, 139, 0.18);
          color: #1e293b;
          border-radius: 0;
          padding: 5px 12px;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.2px;
        }

        .wf-stats-chip i {
          font-size: 14px;
          color: #1e293b;
        }

        .search-panel-collapse {
          background: #ffffff !important;
          backdrop-filter: blur(16px) !important;
          -webkit-backdrop-filter: blur(16px) !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: #ffffff !important;
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-header-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: rgba(37, 99, 235, 0.07);
          border: 1px solid rgba(37, 99, 235, 0.15);
          color: #1d4ed8;
          border-radius: 0;
          padding: 3px 10px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .search-panel-collapse input,
        .search-panel-collapse textarea,
        .search-panel-collapse select {
          font-weight: 400 !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226, 232, 240, 0.7);
          background: #ffffff;
        }

        .wf-control-label {
          font-size: 11px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 11px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 0 !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .wf-filter-input-no-icon .wf-input {
          padding-left: 14px !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-size: 13.5px !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }

        .wf-select {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
          padding-right: 36px !important;
        }

        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        /* ── Premium Tabs ─────────────────────────────── */
        .wf-tab-bar {
          display: flex;
          align-items: stretch;
          gap: 4px;
          border-bottom: 2px solid #e5e5e5;
          margin-bottom: 0;
          padding: 8px 0 0;
          position: relative;
          flex: 0 0 auto;
        }

        .wf-tab-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: none;
          background: transparent;
          padding: 9px 16px 11px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          cursor: pointer;
          border-radius: 0;
          transition: color 0.2s ease, background 0.2s ease;
          outline: none;
          white-space: nowrap;
        }

        .wf-tab-btn i {
          font-size: 14px;
          color: currentColor;
          transition: color 0.2s ease;
        }

        .wf-tab-btn:hover {
          color: #0f172a;
          background: #f5f5f5;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff;
          font-weight: 500;
          background: #171717;
        }

        .wf-tab-btn.active i {
          color: #ffffff;
        }

        .wf-tab-btn::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          right: 0;
          height: 2px;
          background: #171717;
          border-radius: 0;
          transform: scaleX(0);
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0);
        }

        .wf-tab-badge {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 20px;
          height: 20px;
          padding: 0 6px;
          border-radius: 0;
          font-size: 12px;
          font-weight: 600;
          background: #f1f5f9;
          color: #1e293b;
          border: 1px solid #e2e8f0;
          transition: all 0.2s ease;
          line-height: 1;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        /* Tab content panels */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        body.workflow-user-card-scroll #layout-scroll-wrapper {
          overflow-y: auto !important;
        }

        body.workflow-user-card-scroll .modern-breadcrumb-container {
          margin-bottom: 10px !important;
        }

        .wf-main-card > .card-body:not(.wf-tabs-container) {
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        .wf-tab-panel::-webkit-scrollbar,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-tab-panel::-webkit-scrollbar-track,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb:hover,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        /* Enhanced empty state */
        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-roles-empty-state {
          min-height: 250px;
          width: 100%;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: linear-gradient(135deg, rgba(37,99,235,0.08) 0%, rgba(124,58,237,0.06) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          color: #2563eb;
          margin-bottom: 4px;
        }

        .wf-empty-title {
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
          width: 100%;
          text-align: center;
        }

        .wf-empty-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          text-align: center;
          width: 100%;
        }

        .wf-tab-empty-state .wf-empty-icon {
          background: #171717;
          border-color: #171717;
          color: #ffffff;
        }

        .wf-tab-empty-state .wf-empty-title {
          color: #1e293b;
        }

        .wf-tab-empty-state .wf-empty-desc {
          color: #64748b;
        }

        .wf-roles-empty-state .wf-empty-icon {
          background: #171717;
          border-color: #171717;
          color: #ffffff;
        }

        .wf-roles-empty-state .wf-empty-title {
          color: #1e293b;
        }

        .wf-roles-empty-state .wf-empty-desc {
          color: #64748b;
        }

        /* Assign card */
        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: #ffffff;
          border: 1px solid #d4d4d4;
          border-radius: 0;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-assign-actions .btn-danger-search {
          padding: 7px 14px !important;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 0;
          background: #171717;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          flex-shrink: 0;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 3px;
        }

        .wf-assign-meta span {
          font-size: 12px;
          color: #64748b;
          font-weight: 400;
        }

        /* Modern Table Style */
        .wf-table-scroll table,
        .wf-table-scroll .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: none !important;
        }

        .wf-table-scroll {
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
        }

        .wf-table-scroll::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-table-scroll::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-table-scroll::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        .wf-thead {
          background: #f8fafc !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
        }

        .wf-table-row:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-row:hover td {
          color: #1e293b !important;
        }

        .wf-table-row:active {
          transform: scaleY(0.98) !important;
        }

        .wf-table-row.selected-row {
          background: #f5f5f5 !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }

        .wf-table-row.selected-row:hover {
          background: #eeeeee !important;
        }

        .wf-table td {
          padding: 13px 16px !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          border-bottom: 1px solid #f1f5f9 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          vertical-align: middle !important;
          transition: color 0.15s ease !important;
        }

        .wf-table tbody tr:last-child td,
        .wf-table-row.selected-row:last-child td,
        .wf-table tbody tr:last-child.selected-row td {
          border-bottom: none !important;
        }

        /* Row index fade-in */
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-table-row {
          animation: rowFadeIn 0.25s ease both !important;
        }

        /* Pill Badges */
        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 4px 10px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          line-height: 1 !important;
        }

        .badge-unrestricted {
          color: #475569 !important;
        }

        .badge-count {
          color: #1d4ed8 !important;
        }

        .badge-users {
          color: #1d4ed8 !important;
        }

        .badge-zero {
          color: #64748b !important;
        }

        /* Alert Warning */
        .wf-alert-warning {
          background: rgba(239, 68, 68, 0.04) !important;
          border: 1px solid rgba(239, 68, 68, 0.15) !important;
          border-radius: 0 !important;
          padding: 16px 20px !important;
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          margin-top: 10px !important;
          animation: searchSlideDown 0.3s ease-out both;
        }

        .wf-alert-icon {
          color: #dc2626 !important;
          font-size: 20px !important;
        }

        .wf-alert-text {
          color: #dc2626 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          margin: 0 !important;
        }

        /* Radio Styling */
        .wf-radio-container {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .wf-radio-input {
          width: 16px !important;
          height: 16px !important;
          accent-color: #2563eb !important;
          cursor: pointer !important;
        }

        /* Search Actions — matched to TopMenu quickButton */
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }

        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }

        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        /* ── Premium Table Empty State ───────────────────── */
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyPulse {
          0%, 100% { transform: scale(1);   opacity: 0.5; }
          50%       { transform: scale(1.15); opacity: 1;   }
        }
        @keyframes emptyOrbit {
          from { transform: rotate(0deg) translateX(38px) rotate(0deg); }
          to   { transform: rotate(360deg) translateX(38px) rotate(-360deg); }
        }
        @keyframes emptyOrbit2 {
          from { transform: rotate(180deg) translateX(52px) rotate(-180deg); }
          to   { transform: rotate(540deg) translateX(52px) rotate(-540deg); }
        }
        @keyframes emptyFloat {
          0%, 100% { transform: translateY(0px);  }
          50%       { transform: translateY(-6px); }
        }
        @keyframes emptyGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,99,235,0.18), 0 0 0 8px rgba(37,99,235,0.06); }
          50%       { box-shadow: 0 0 0 6px rgba(37,99,235,0.12), 0 0 0 14px rgba(37,99,235,0.04); }
        }
        @keyframes emptySparkle {
          0%,100% { opacity:0; transform: scale(0.5) rotate(0deg);   }
          50%      { opacity:1; transform: scale(1)   rotate(180deg); }
        }
        @keyframes emptyDotPulse {
          0%,100% { opacity:0.25; } 50% { opacity:0.7; }
        }

        .wf-table-empty {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 56px 24px 48px;
          text-align: center;
          overflow: hidden;
          background: #f8faff;
          border-radius: 0;
          margin: 12px;
          border: 1.5px solid rgba(37,99,235,0.1);
          animation: emptyFadeUp 0.45s cubic-bezier(0.16,1,0.3,1) both;
        }

        /* Soft blob backgrounds */
        .wf-table-empty::before {
          content: '';
          position: absolute;
          width: 260px; height: 260px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(37,99,235,0.07) 0%, transparent 70%);
          top: -60px; left: -60px;
          pointer-events: none;
        }
        .wf-table-empty::after {
          content: '';
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%);
          bottom: -40px; right: -40px;
          pointer-events: none;
        }

        /* Dot grid */
        .wf-te-dots {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(37,99,235,0.12) 1px, transparent 1px);
          background-size: 22px 22px;
          opacity: 0.35;
          pointer-events: none;
        }

        /* Orbit container */
        .wf-te-orbit-wrap {
          position: relative;
          width: 110px; height: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          z-index: 1;
        }

        /* Pulsing ring */
        .wf-te-ring {
          position: absolute;
          inset: -6px;
          border-radius: 50%;
          border: 1.5px solid rgba(37,99,235,0.15);
          animation: emptyGlow 2.4s ease-in-out infinite;
        }
        .wf-te-ring2 {
          position: absolute;
          inset: -18px;
          border-radius: 50%;
          border: 1px dashed rgba(37,99,235,0.1);
          animation: emptyGlow 2.4s ease-in-out 0.8s infinite;
        }

        /* Orbiting dots */
        .wf-te-orb {
          position: absolute;
          width: 8px; height: 8px;
          border-radius: 50%;
          background: linear-gradient(135deg,#2563eb,#7c3aed);
          top: 50%; left: 50%;
          margin: -4px 0 0 -4px;
          animation: emptyOrbit 3.5s linear infinite;
          box-shadow: 0 2px 6px rgba(37,99,235,0.35);
        }
        .wf-te-orb2 {
          position: absolute;
          width: 6px; height: 6px;
          border-radius: 50%;
          background: linear-gradient(135deg,#7c3aed,#ec4899);
          top: 50%; left: 50%;
          margin: -3px 0 0 -3px;
          animation: emptyOrbit2 5s linear infinite;
          box-shadow: 0 2px 5px rgba(124,58,237,0.3);
        }

        /* Icon circle */
        .wf-te-icon {
          width: 72px; height: 72px;
          border-radius: 50%;
          background: linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%);
          border: 2px solid rgba(37,99,235,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #2563eb;
          position: relative;
          z-index: 2;
          animation: emptyFloat 3s ease-in-out infinite;
          box-shadow: 0 8px 24px rgba(37,99,235,0.12), 0 2px 8px rgba(0,0,0,0.04);
          transition: all 0.3s ease;
        }
        .wf-table-empty:hover .wf-te-icon {
          background: linear-gradient(135deg,rgba(37,99,235,0.1) 0%,rgba(124,58,237,0.08) 100%);
          border-color: rgba(37,99,235,0.3);
          box-shadow: 0 12px 32px rgba(37,99,235,0.2);
          color: #1d4ed8;
        }

        /* Sparkle dots */
        .wf-te-spark {
          position: absolute;
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #2563eb;
          z-index: 1;
        }
        .wf-te-spark:nth-child(1) { top:8px;  right:12px; background:#7c3aed; animation:emptySparkle 2.2s 0.0s infinite; }
        .wf-te-spark:nth-child(2) { bottom:8px; left:14px; background:#2563eb; animation:emptySparkle 2.2s 0.7s infinite; }
        .wf-te-spark:nth-child(3) { top:22px; left:6px;   background:#ec4899; animation:emptySparkle 2.2s 1.4s infinite; width:4px;height:4px; }

        /* Text */
        .wf-te-label {
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #2563eb;
          background: rgba(37,99,235,0.07);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 0;
          padding: 3px 12px;
          margin-bottom: 10px;
          z-index: 1;
        }

        .wf-te-title {
          font-size: 18px;
          font-weight: 600;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0 0 10px 0;
          line-height: 1.3;
          z-index: 1;
        }

        .wf-te-desc {
          font-size: 14px;
          font-weight: 400;
          color: #64748b;
          margin: 0 0 22px 0;
          max-width: 340px;
          line-height: 1.65;
          z-index: 1;
        }

        .wf-te-cta {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          background: #2563eb !important;
          color: #ffffff !important;
          border: none !important;
          padding: 10px 22px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.25s ease !important;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3) !important;
          z-index: 1;
          position: relative;
        }
        .wf-te-cta:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(37,99,235,0.4) !important;
          background: #1d4ed8 !important;
        }
        .wf-te-cta:active {
          transform: translateY(0px) !important;
        }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card workflow-user-page">
          <div className="wf-card-header-bar">
            {isLoading && <div className="wf-loading-bar" />}
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                {totalUsers} Active Users
              </span>
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn-search-trigger"
                data-toggle="collapse"
                data-target="#collapseExample"
              >
                <i className="fa fa-filter" aria-hidden="true" /> Filters
              </button>
              <button
                className="btn-search-trigger"
                onClick={handleRefresh}
                disabled={isLoading}
                title="Reload roles"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>
          <div className="px-3">
            <div className="collapse" id="collapseExample">
              <div className="search-panel-collapse">

                {/* Panel Header */}
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Workflow Roles
                  </span>
                </div>

                {/* Filter Fields */}
                <div className="sp-body">
                  <div className="row">

                    {/* Role ID */}
                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="rId" className="wf-control-label">
                        Role ID
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="rId"
                          id="rId"
                          className="form-control wf-input"
                          placeholder="e.g. 1042"
                          value={rId}
                          onChange={({ currentTarget }) => setRId(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    {/* Role Type */}
                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="roleType" className="wf-control-label">
                        Role Type
                      </label>
                      <SearchableSelect
                        id="roleType"
                        name="roleType"
                        placeholder="All Role Types"
                        value={rType}
                        onChange={setrType}
                        options={roleTypes.map((r) => ({
                          value: r.name,
                          label: r.name,
                        }))}
                      />
                    </div>

                    {/* Role Name */}
                    <div className="col-md-4 form-group mb-3">
                      <label htmlFor="userName" className="wf-control-label">
                        Role Name
                      </label>
                      <div className="wf-input-wrap wf-filter-input-no-icon">
                        <input
                          type="text"
                          name="userName"
                          id="userName"
                          className="form-control wf-input"
                          placeholder="Search role name…"
                          value={rName}
                          onChange={({ currentTarget }) => setrName(currentTarget.value)}
                          onKeyDown={e => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Action Footer */}
                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={handleFilterCancel}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter()}
                    disabled={isFiltering || (!rName.trim() && !rType && !rId.trim())}
                  >
                    {isFiltering ? (
                      <>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" /> Applying...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                      </>
                    )}
                  </button>
                </div>

              </div>
            </div>
          </div>
          <div className="card-body px-3 pt-0 pb-3 wf-tabs-container">

            {/* Custom Tab Bar */}
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedKey === "home" ? " active" : ""}`}
                onClick={() => handleTabSelect("home")}
              >
                <i className="fa fa-list-alt" />
                Workflow Roles
                <span className="wf-tab-badge">{workflowRoles.length > 0 ? rowsCount : "—"}</span>
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "profile" ? " active" : ""}${selectedRoleId === 0 ? " tab-locked" : ""}`}
                onClick={() => handleTabSelect("profile")}
              >
                <i className="fa fa-shield" />
                {selectedRoleId > 0 ? "Edit" : "Add"} Permissions
                {selectedRoleId > 0 && (
                  <span className="wf-tab-badge">#{selectedRoleId}</span>
                )}
              </button>
              <button
                className={`wf-tab-btn${selectedKey === "users" ? " active" : ""}${selectedRoleId === 0 ? " tab-locked" : ""}`}
                onClick={() => {
                  if (selectedRoleId > 0) {
                    handleManagePerformer();
                  } else {
                    handleTabSelect("users");
                  }
                }}
              >
                <i className="fa fa-users" />
                Assign / Manage Users
                {selectedRoleId > 0 && (
                  <span className="wf-tab-badge">#{selectedRoleId}</span>
                )}
              </button>
            </div>

            {/* Tab Panels */}
            {selectedKey === "home" && (
              <div className="wf-tab-panel">

                {/* Selected role context card */}
                {selectedRoleId > 0 && selectedObj && (
                  <div className="wf-assign-card" style={{ marginTop: 8, marginBottom: 14 }}>
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj.rolename || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedObj.rolename}</strong>
                        <span>
                          {selectedObj.roleType}
                          {selectedObj.maxusers && <> &bull; Max {selectedObj.maxusers} users</>}
                        </span>
                      </div>
                    </div>
                    <div className="wf-assign-actions">
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("profile")}
                      >
                        Permissions
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabSelect("users")}
                      >
                        Assign Users
                      </button>
                      <button
                        className="btn-action-search"
                        onClick={handleManagePerformer}
                      >
                        Manage Users
                      </button>
                      <button
                        className="btn-action-search btn-danger-search"
                        onClick={handleResetSelection}
                        title="Clear selection"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}
                <div className="table-responsive mt-2 wf-table-scroll">
                  <table className="table align-items-center table-flush table-striped wf-table">
                    <thead className="wf-thead">
                      <tr>
                        <th>ID</th>
                        <th>Role Type</th>
                        <th>Role Name</th>
                        <th>Date & Time</th>
                        <th>Maximum Users</th>
                        <th>Total Users</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        Array.from({ length: pageSize > 5 ? 5 : pageSize }).map((_, i) => (
                          <tr key={`skel-${i}`} className="skeleton-row">
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                          </tr>
                        ))
                      ) : workflowRoles.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ padding: 0 }}>
                            <div className="wf-empty-state wf-roles-empty-state">
                              <div className="wf-empty-icon">
                                <i className={dataType === "filter" ? "fa fa-search" : "fa fa-list-alt"} />
                              </div>
                              <p className="wf-empty-title">
                                {dataType === "filter" ? "No Matching Roles" : "No Workflow Roles Found"}
                              </p>
                              <p className="wf-empty-desc">
                                {dataType === "filter"
                                  ? "Try adjusting or resetting the filters to see workflow roles."
                                  : "There are no workflow roles configured in this system yet. Once roles are created they'll appear here."}
                              </p>
                              {dataType === "filter" && (
                                <button
                                  className="btn-action-search"
                                  onClick={handleFilterCancel}
                                  style={{ marginTop: 4 }}
                                >
                                  <i className="fa fa-refresh" aria-hidden="true" />
                                  Reset Filters
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ) : (
                        workflowRoles.map((item, idx) => (
                          <tr
                            key={item.roleid}
                            className={`wf-table-row ${selectedRoleId === item.roleid ? "selected-row" : ""}`}
                            onClick={() => handleSelectRole(item)}
                            style={{ animationDelay: `${idx * 0.04}s` }}
                            title={selectedRoleId === item.roleid ? `Click to deselect: ${item.rolename}` : `Click to select: ${item.rolename}`}
                          >
                            <td>
                              <span style={{
                                color: "#1e293b",
                                fontSize: "14px",
                                fontWeight: 400,
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px"
                              }}>
                                #{item.roleid}
                              </span>
                            </td>
                            <td>
                              <span style={{
                                display: "inline-flex", alignItems: "center", gap: "5px",
                                borderRadius: "0px", padding: "3px 9px",
                                fontSize: "14px", fontWeight: 400, color: "#1e293b"
                              }}>
                                {item.roleType}
                              </span>
                            </td>
                            <td style={{ color: "#1e293b", fontWeight: 400 }}>{item.rolename}</td>
                            <td>
                              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>

                                <span style={{
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  color: "#1e293b"
                                }}>
                                  <Moment format="MMM Do YYYY, h:mm a">{item.dateTimeChanged}</Moment>
                                </span>
                              </div>
                            </td>
                            <td>
                              {item.totalEntryRecords === 0 ? (
                                <span className="badge-capsule badge-unrestricted">Unrestricted</span>
                              ) : (
                                <span className="badge-capsule badge-count">{item.totalEntryRecords}</span>
                              )}
                            </td>
                            <td>
                              {item.activeUsers === 0 ? (
                                <span className="badge-capsule badge-zero">{item.activeUsers}</span>
                              ) : (
                                <span className="badge-capsule badge-users">{item.activeUsers}</span>
                              )}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <div style={{ display: "none" }}>
                  </div>
                  <div className="mt-3">
                    <Pagination
                      currentPage={currentPage}
                      pageSize={pageSize}
                      itemsCount={rowsCount}
                      onPageChange={handlePageChange}
                      startIndex={startIndex}
                      endIndex={endIndex}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Permissions Panel */}
            {selectedKey === "profile" && (
              <div className="wf-tab-panel pt-2">
                {selectedRoleId > 0 ? (
                  <AddEditPermission
                    roleid={selectedRoleId}
                    roleSource="main"
                    handlePermissionShowHide={handlePermissionShowHide}
                  />
                ) : (
                  <div className="wf-empty-state wf-tab-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-shield" />
                    </div>
                    <p className="wf-empty-title">No Role Selected</p>
                    <p className="wf-empty-desc">
                      Select a workflow role from the table to view or edit its permissions.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Roles
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Assign Users Panel */}
            {selectedKey === "users" && (
              <div className="wf-tab-panel pt-3">
                {selectedRoleId > 0 ? (
                  <div className="wf-assign-card">
                    <div className="wf-assign-info">
                      <div className="wf-assign-avatar">
                        {(selectedObj?.rolename || "?").charAt(0).toUpperCase()}
                      </div>
                      <div className="wf-assign-meta">
                        <strong>{selectedObj?.rolename || "Selected Role"}</strong>
                        <span>
                          {selectedObj?.roleType || ""}
                        </span>
                      </div>
                    </div>
                    <button
                      className="btn-action-search"
                      onClick={handleManagePerformer}
                      style={{ padding: "10px 20px", fontSize: "14px" }}
                    >
                      <i className="fa fa-users" /> Manage Users
                    </button>
                  </div>
                ) : (
                  <div className="wf-empty-state wf-tab-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-users" />
                    </div>
                    <p className="wf-empty-title">No Role Selected</p>
                    <p className="wf-empty-desc">
                      Select a workflow role from the table to assign or manage its users.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Roles
                    </button>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
